module.exports = __webpack_public_path__ + "static/media/profile.1706c7e6.png";